import { isAtMostMobile, useBreakpointRange } from '@optimus-web/breakpoints';
import { IconName } from '@optimus-web/icons';
import { OptimusTextKey, useLocalization } from '@optimus-web/localization';
import { UnicodeEntity } from '@mews/enums';
import { useId } from '@optimus-web/helpers';
import { VisuallyHidden } from '../helpers';
import { BreakpointRangeWithFallback } from '../types';
import { ensureString, getBreakpointRangeValueFallback } from '../utils';
import { AccordionIconButtonElement } from './style';

interface AccordionIconButtonProps {
    expanded: boolean;
    title: React.ReactNode;
}

export const AccordionIconButton = ({ expanded, title }: AccordionIconButtonProps) => {
    const { t } = useLocalization();
    const breakpointRange = useBreakpointRange<BreakpointRangeWithFallback>();
    const isMobile = isAtMostMobile(getBreakpointRangeValueFallback(breakpointRange));

    const buttonLabelId = useId('accordion-button-label');

    return (
        <>
            <VisuallyHidden as="span" id={buttonLabelId} aria-hidden>
                {expanded
                    ? ensureString({ value: t(OptimusTextKey.CollapseAccordion) })
                    : ensureString({ value: t(OptimusTextKey.ExpandAccordion) })}
                {UnicodeEntity.Comma}
                {UnicodeEntity.Space}
                {title}
            </VisuallyHidden>
            <AccordionIconButtonElement
                aria-labelledby={buttonLabelId}
                icon={IconName.ChevronDown}
                expanded={expanded}
                aria-expanded={expanded}
                size={isMobile ? 'medium' : 'small'}
            />
        </>
    );
};
